import { Stack, Avatar, Typography, TextField, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { alert } from "src/services/alert";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import UserInfo from "src/components/common/UserInfo";
import { asyncRequest } from "src/services/network";
import MerchantPicker from "src/components/common/MerchantPicker";
import UserPicker from "src/components/common/UserPicker";
import Confirm from "src/components/common/ConfirmDialog";
import StoreProductPicker from "src/components/common/StoreProductPicker";

const StoreOrderAddDialog = ({ open, onClose, onFinish }) => {
  const [form, setForm] = useState({
    amount: "1",
    remark: "",
  });

  const [product, setStoreProduct] = useState({});
  const [user, setUser] = useState({});
  const [submitting, setSubmitting] = useState(false);

  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleConfirm() {
    if (Number.isNaN(parseFloat(form.amount))) return alert("数量不能为空");
    if (!user.uid) return alert("请选择用户");
    if (!product.mid) return alert("请选择商品");

    Confirm({
      message: `确定用户${user.uid}购买${form.amount}件商品吗？`,
      async onConfirm() {
        setSubmitting(true);

        const { msg } = await asyncRequest({
          path: "/store/order/add",
          data: {
            ...form,
            uid: user.uid,
            productId: product.id,
          },
          complete() {
            setSubmitting(false);
          },
        });

        alert(msg, "success");
        onFinish();
      },
    });
  }

  function handleSelectStoreProduct() {
    StoreProductPicker({
      onSelect(val) {
        console.log(val);
        setStoreProduct(val);
      },
    });
  }

  function handleSelectUser() {
    UserPicker({
      onSelect(val) {
        console.log(val);
        setUser(val);
      },
    });
  }

  return (
    <FormDialog title="添加商城订单" open={open} onClose={onClose} submitting={submitting} onConfirm={handleConfirm}>
      <FormItem title="商品" required sx={{ width: 500 }}>
        <TextField fullWidth placeholder="请选择商品" autoComplete="off" id="merchant" value={product.name || ""} size="small" onClick={() => handleSelectStoreProduct()} />
      </FormItem>

      {/* {!!product.mid && (
        <FormItem title="商品版本" sx={{ width: 500 }}>
          <TextField fullWidth disabled autoComplete="off" id="merchant" value={product.version + ".0"} size="small" />
        </FormItem>
      )} */}

      <FormItem title="用户" required>
        <Stack onClick={handleSelectUser}>
          <UserInfo {...user} enablePreview={false} />
        </Stack>
      </FormItem>

      <FormItem title="数量" required>
        <TextField fullWidth type="number" placeholder="数量" autoComplete="off" id="amount" value={form.amount} size="small" onChange={(e) => handleIptChange("amount", e.target.value)} />
      </FormItem>

      <FormItem title="密码" required>
        <TextField fullWidth placeholder="密码" autoComplete="off" id="password" value={form.password} size="small" onChange={(e) => handleIptChange("password", e.target.value)} />
      </FormItem>

      <FormItem title="备注">
        <TextField fullWidth placeholder="备注" autoComplete="off" id="remark" value={form.remark} size="small" onChange={(e) => handleIptChange("remark", e.target.value)} />
      </FormItem>
    </FormDialog>
  );
};

export default StoreOrderAddDialog;
